import api from '@/apis'
import { mockDelay } from '@/apis/mockDelay'
import { IS_MOCK } from '@/constants'
import type { QuizListResponse } from '@/types/quiz'

import { MOCK_QUIZ_LIST } from './mocks'

export const apiGetQuizzes = async (): Promise<QuizListResponse> => {
  if (IS_MOCK) {
    await mockDelay()
    return MOCK_QUIZ_LIST
  }
  return await api.get<QuizListResponse>('/quizzes')
}
